angular.module('unica_media_directory.media_directory_controllers')

.controller('ArchiveMediaDirectoryCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	MediaDirectoryCreateService
) {

	$scope.archive = true;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );

	$scope.pageTitle = 'Aggiungi Directory';

	$scope.event_id = $stateParams.event_id;

	$rootScope.mediaDirectoryData = {
		event_id: $stateParams.event_id,
		title: ''
	};

	$scope.saveMediaDirectory = function() {
		$scope.showLoader();

		var mediaDirectoryData = angular.copy($rootScope.mediaDirectoryData);

		mediaDirectoryData['archive'] = true;

		console.log(mediaDirectoryData);

		MediaDirectoryCreateService
			.createArchive(mediaDirectoryData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Archivio Media Directory aggiunta con successo!', '');
					if ( $state.current.name === 'app.archive_event.directory_create' ) {
						$state.go('app.archive_event.directory_list', { year: $rootScope.year, event_id: $stateParams.event_id });
					} else {
						$state.go('app.archive_media_directory.list', { event_id: $stateParams.event_id });
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})

;